var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-array/src/array.js
// module id = 498
// module chunks = 0